import React, { useState, useEffect, useRef } from "react";
import SaveFormButton from "./saveFormButton";

const EditableField = ({ value, placeholder, onChange, className }) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef(null);

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleBlur();
    }
  };

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [isEditing]);

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        className={`form-control form-control-sm ${className}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
    );
  }

  return (
    <div
      className={`editable-field d-flex align-items-center ${className}`}
      onDoubleClick={handleDoubleClick}
    >
      <span className="me-2">{value || placeholder}</span>
      <i
        className="bi bi-pencil text-muted"
        style={{ cursor: "pointer", fontSize: "0.75rem" }}
        onClick={handleDoubleClick}
      ></i>
    </div>
  );
};

const FormBuilderNavbar = ({
  showPreview,
  setShowPreview,
  navigate,
  formId,
  refresh,
  isEditing = false,
  formTitle = "",
  formDescription = "",
}) => {
  const [formData, setFormData] = useState({
    title: isEditing ? formTitle : "Untitled Form",
    description: isEditing ? formDescription : "",
  });

  // Update formData when props change
  useEffect(() => {
    console.log("formBUidler name and description", formTitle, formDescription);
    if (isEditing) {
      setFormData((prev) => ({
        ...prev,
        title: formTitle || "Untitled Form",
        description: formDescription || "",
      }));
    }
  }, [isEditing, formTitle, formDescription]);

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-white mb-0"
      style={{
        height: "7vh",
        borderBottom: "1px solid #B1B4BFFF",
      }}
    >
      <div className="container-fluid">
        <div className="d-flex flex-column align-items-start">
          <div className="d-flex align-items-center mb-1">
            <div className="me-2">
              <EditableField
                value={formData.title}
                placeholder="Form Title"
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, title: value }))
                }
                className="me-2"
                style={{ width: "200px" }}
              />
            </div>
            <div>
              <EditableField
                value={formData.description}
                placeholder="Form Description (optional)"
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, description: value }))
                }
                style={{ width: "300px" }}
              />
            </div>
          </div>

          {/* Editing badge moved below */}
          {isEditing && (
            <div>
              <span className="badge bg-primary text-white small">
                <i className="bi bi-pencil me-1"></i>
                Editing
              </span>
            </div>
          )}
        </div>

        <div className="navbar-nav flex-row">
          {/* Show Design button only when in preview mode */}
          {showPreview && (
            <div className="nav-item me-3">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => setShowPreview(false)}
              >
                <i className="bi bi-layout-text-window-reverse me-1"></i>
                Design
              </button>
            </div>
          )}

          {/* Show Preview button only when in design mode */}
          {!showPreview && (
            <div className="nav-item me-3">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => setShowPreview(true)}
              >
                <i className="bi bi-eye me-1"></i>
                Preview
              </button>
            </div>
          )}

          <div className="nav-item">
            <SaveFormButton
              navigate={navigate}
              refresh={refresh}
              formId={formId}
              isEditing={isEditing}
              formData={formData} // Pass formData to SaveFormButton
            />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default FormBuilderNavbar;
